export const en = {
  'enum.leaveStatus.CANCELLATION_REQUESTED': 'Cancellation asked',
  'leave.workingDays.one': '{count} working day',
  'leave.workingDays.other': '{count} working days',
  'leave.warning.one': '{names} is off then too; the department allows {limit} at a time.',
  'leave.warning.other': '{names} are off then too; the department allows {limit} at a time.',
  'leave.quoted': '“{text}”',
  'leave.unpaid': 'Unpaid',
  'leave.unpaidSuffix': 'unpaid',
  'leave.waitingApproval': 'Waiting for approval',
  'leave.firstDay': 'First day',
  'leave.lastDay': 'Last day',
  'leave.requestUpdated': 'Request updated',
  'leave.recorded': 'Leave recorded',
  'leave.sent': 'Request sent for approval',
  'leave.employee': 'Employee',
  'leave.choosePerson': 'Choose a person',
  'leave.type': 'Type',
  'leave.upTo.one': 'Up to {count} working day',
  'leave.upTo.other': 'Up to {count} working days',
  'leave.noLimit': 'No limit per request',
  'leave.noteHint': 'Optional. Approvers and the accountant see it; colleagues on the calendar do not.',
  'leave.recordApproved': 'Record as approved',
  'leave.recordApprovedHint': 'For leave already agreed or already taken; notice rules do not apply to a record.',
  'leave.pickDates': 'Pick the dates to see how many working days this is.',
  'leave.counting': 'Counting…',
  'leave.leftAfter': '{after} of {total} left after this',
  'leave.leftThisYear': '{left} left this year',
  'leave.noAllowance': 'Does not use the annual allowance',
  'leave.skips': 'Skips {dates}',
  'leave.saveDates': 'Save dates',
  'leave.recordLeave': 'Record leave',
  'leave.fileRequest': 'File request',
  'leave.sendRequest': 'Send request',
  'leave.you': '{name} (you)',

  'leaveRule.LEAVE_DATES_BACKWARDS': 'The last day is before the first.',
  'leaveRule.LEAVE_TYPE_UNAVAILABLE': 'This kind of leave is not available to this person.',
  'leaveRule.LEAVE_OUTSIDE_EMPLOYMENT': 'The dates fall outside the employment.',
  'leaveRule.LEAVE_NO_WORKING_DAYS': 'There is no working day in these dates.',
  'leaveRule.LEAVE_OVERLAPS': 'These dates overlap another request of the same person.',
  'leaveRule.LEAVE_MAX_CONSECUTIVE.one': 'At most {count} working day in one request.',
  'leaveRule.LEAVE_MAX_CONSECUTIVE.other': 'At most {count} working days in one request.',
  'leaveRule.LEAVE_NOT_ELIGIBLE': 'Available after the starting period, from {date}.',
  'leaveRule.LEAVE_TOO_FAR_AHEAD.one': 'Can be requested at most {count} day ahead.',
  'leaveRule.LEAVE_TOO_FAR_AHEAD.other': 'Can be requested at most {count} days ahead.',
  'leaveRule.LEAVE_MIN_NOTICE.one': "Needs {count} day's notice: the first day can be {date} at the earliest.",
  'leaveRule.LEAVE_MIN_NOTICE.other': "Needs {count} days' notice: the first day can be {date} at the earliest.",
  'leaveRule.notInPast': 'The first day cannot be in the past. An approver can record days already taken.',
  'leaveRule.LEAVE_ALLOWANCE_EXCEEDED.one': 'Only {count} day is left in {year}.',
  'leaveRule.LEAVE_ALLOWANCE_EXCEEDED.other': 'Only {count} days are left in {year}.',

  'leavePage.description': 'Who is off when, your balance and your requests. Leave is counted in working days.',
  'leavePage.reportSick': 'Report sick',
  'leavePage.requestHint': 'Working days are counted as you pick the dates; an approver then decides.',
  'leavePage.noRecordHint': 'You can see who is off, but requesting leave needs an employee record. Ask the owner to add you under Team → Employees and link it to your login.',
  'leavePage.noRecordHintManager': 'You can see who is off. To request leave or report sick yourself, add yourself to the team and link the record to your login.',
  'leavePage.addMe': 'Add yourself to the team',
  'sick.description': 'Today is filled in; change the last day if you know it. A doctor’s note can go with it now or be added later.',
  'sick.descriptionApprover': 'For yourself, or for someone on the team who called in sick. Notice does not apply when you record it for someone else, so a day already past is fine.',
  'sick.descriptionOthers': 'For someone on the team who called in sick. Notice does not apply to a record you make for someone else, so a day already past is fine.',
  'sick.unavailable': 'Sick leave is switched off',
  'sick.unavailableHint': 'Ask the owner to switch it on under Team → Leave settings.',
  'myPay.description': 'Your payslips and, if you are paid by the hour, the hours you worked.',

  'approvals.description': 'Leave waiting for a decision, soonest first. A warning means the department would have more people off than it allows; it never blocks.',
  'approvals.fileForSomeone': 'File leave for someone',
  'approvals.fileDescription': 'For a person without a login, or leave agreed in person. The same rules apply, except notice.',
  'approvals.empty': 'Nothing to decide',
  'approvals.emptyHint': 'New requests and requests to cancel approved leave show up here.',
  'approvals.wantsToCancel': 'Wants to cancel: “{reason}”',
  'approvals.filedBy': 'Filed by {name}',
  'approvals.ownLeave': 'Your own leave: someone else decides it.',
  'approvals.keepApproved': 'Keep approved',
  'approvals.cancelLeave': 'Cancel leave',
  'approvals.reject': 'Reject',
  'approvals.approve': 'Approve',
  'approvals.summary': '{name} · {type} · {range} ({days})',
  'approvals.approveTitle': 'Approve leave',
  'approvals.approveNote': 'Note to the person (optional)',
  'approvals.sessions.count.one': '{count} one-to-one session is booked with {name} on these days',
  'approvals.sessions.count.other': '{count} one-to-one sessions are booked with {name} on these days',
  'approvals.sessions.choose': 'Choose what happens to them before you approve.',
  'approvals.sessions.cancel': 'Cancel them: each member is told and gets the session back',
  'approvals.sessions.keep': 'Keep them booked',
  'approvals.approved': '{name}: approve',
  'approvals.rejectTitle': 'Reject leave',
  'approvals.whyVisible': 'Why (optional, the person sees it)',
  'approvals.rejected': '{name}: reject',
  'approvals.cancelTitle': 'Cancel this leave',
  'approvals.cancelConfirm': 'Cancel the leave',
  'approvals.cancelNote': 'Note (optional)',
  'approvals.cancelled': '{name}: cancel the leave',
  'approvals.keepTitle': 'Keep the leave approved',
  'approvals.kept': '{name}: keep approved',

  'timeOff.noRecord': 'You have no employee record here',
  'timeOff.noRecordHint': 'Leave and pay hang off an employee record. Ask the owner to add you to the team under Team → Employees and link it to your login.',
  'timeOff.tab.payslips': 'Payslips',
  'timeOff.request': 'Request leave',
  'timeOff.noTypes': 'No leave types available',
  'timeOff.noTypesHint': 'Ask the owner which kinds of leave you can take.',
  'timeOff.yourRequests': 'Your requests',
  'timeOff.noRequests': 'No requests yet',
  'timeOff.noRequestsHint': 'Requests you send show here with their status.',
  'timeOff.leftIn': 'Left in {year}',
  'timeOff.leftHint': 'Working days, after pending requests',
  'timeOff.taken': 'Taken or approved',
  'timeOff.takenHint': 'From types that use the allowance',
  'timeOff.startingPeriod': 'Starting period',
  'timeOff.eligibleFrom': 'Eligible from',
  'timeOff.done': 'Done',
  'timeOff.resetsOn': 'The allowance starts again on {date}',
  'timeOff.withdrawn': 'Request withdrawn',
  'timeOff.cancellationAsked': 'Cancellation asked for',
  'timeOff.youAskedToCancel': 'You asked to cancel: {reason}',
  'timeOff.dates': 'Dates',
  'timeOff.withdraw': 'Withdraw',
  'timeOff.askToCancel': 'Ask to cancel',
  'timeOff.changeDates': 'Change the dates',
  'timeOff.changeDatesHint': 'The request stays pending and the rules run again.',
  'timeOff.askToCancelTitle': 'Ask to cancel this leave?',
  'timeOff.askToCancelHint': 'Approved leave is cancelled when an approver agrees; the days come back then.',
  'timeOff.keepIt': 'Keep it',
  'timeOff.why': 'Why',

  'leaveCalendar.today': 'Today',
  'leaveCalendar.whose': 'Whose leave',
  'leaveCalendar.mine': 'Mine',
  'leaveCalendar.team': 'Team',
  'leaveCalendar.layout': 'Layout',
  'leaveCalendar.layoutMonth': 'Month',
  'leaveCalendar.layoutPeople': 'By person',
  'leaveCalendar.more': '+{count} more',
  'leaveCalendar.onLeave.one': '{count} on leave',
  'leaveCalendar.onLeave.other': '{count} on leave',
  'leaveCalendar.nobodyOffDay': 'Nobody is off this day.',
  'leaveCalendar.youAreNotOff': 'You are not off this day.',
  'leaveCalendar.requestFrom': 'Request leave from this day',
  'leaveCalendar.sick': 'Sick leave',
  'leaveCalendar.off': 'Off',
  'leaveCalendar.previousMonth': 'Previous month',
  'leaveCalendar.nextMonth': 'Next month',
  'leaveCalendar.report': '{year} report',
  'leaveCalendar.department': 'Department',
  'leaveCalendar.allDepartments': 'All departments',
  'leaveCalendar.notWorkingDay': 'Not a working day',
  'leaveCalendar.nobodyOff': 'Nobody is off this month.',
  'leaveCalendar.person': 'Person',
  'leaveCalendar.approved': 'approved',
  'leaveCalendar.pending': 'pending',
  'leaveCalendar.cancellationAsked': 'cancellation asked',
  'leaveCalendar.nobodyWorks': 'Nobody works',

  'leaveSettings.description': 'Leave types, holidays and the working week. Every leave request is counted in working days against these rules.',
  'leaveSettings.tab.types': 'Leave types',
  'leaveSettings.tab.holidays': 'Holidays',
  'leaveSettings.tab.week': 'Working week',
  'leaveSettings.upToPerRequest.one': 'Up to {count} working day per request',
  'leaveSettings.upToPerRequest.other': 'Up to {count} working days per request',
  'leaveSettings.notice.one': "{count} day's notice",
  'leaveSettings.notice.other': "{count} days' notice",
  'leaveSettings.switchedOn': 'Leave type switched on',
  'leaveSettings.switchedOff': 'Leave type switched off',
  'leaveSettings.typeDeleted': 'Leave type deleted',
  'leaveSettings.newType': 'New leave type',
  'leaveSettings.noTypes': 'No leave types',
  'leaveSettings.noTypesHint': 'Add the kinds of leave your team can request.',
  'leaveSettings.paid': 'Paid',
  'leaveSettings.usesAllowance': 'Uses allowance',
  'leaveSettings.afterStartingPeriod': 'After starting period',
  'leaveSettings.attachment': 'Attachment',
  'leaveSettings.grantedPerEmployee': 'Granted per employee',
  'leaveSettings.switchedOffBadge': 'Switched off',
  'leaveSettings.availableNamed': '{name} available on the request form',
  'leaveSettings.available': 'Available',
  'leaveSettings.editNamed': 'Edit {name}',
  'leaveSettings.deleteNamed': 'Delete {name}',
  'leaveSettings.builtinNoDelete': 'Built-in types cannot be deleted; switch it off instead',
  'leaveSettings.deleteTitle': 'Delete leave type?',
  'leaveSettings.deleteDescription': "{name} disappears from the request form and from every employee's grants.",
  'leaveSettings.typeUpdated': 'Leave type updated',
  'leaveSettings.typeAdded': 'Leave type added',
  'leaveSettings.keyStays': 'Key {key} stays the same when the name changes.',
  'leaveSettings.keyFromName': 'The key is made from the English name and never changes.',
  'leaveSettings.addType': 'Add leave type',
  'leaveSettings.nameEnglish': 'Name (English)',
  'leaveSettings.typePlaceholder': 'Wedding leave',
  'leaveSettings.otherLanguages': 'Name in other languages',
  'leaveSettings.longest': 'Longest request (working days)',
  'leaveSettings.longestHint': 'Leave empty for no limit.',
  'leaveSettings.noticeLabel': 'Notice (calendar days)',
  'leaveSettings.noticeHint': 'How far ahead the first day must be.',
  'leaveSettings.paidHint': 'Unpaid days come off a monthly salary in payroll.',
  'leaveSettings.usesAnnual': 'Uses the annual allowance',
  'leaveSettings.usesAnnualHint': "Days taken count against the employee's yearly days.",
  'leaveSettings.onlyAfter': 'Only after the starting period',
  'leaveSettings.onlyAfterHint': 'Set the period on the Working week tab.',
  'leaveSettings.allowsAttachment': 'Allows an attachment',
  'leaveSettings.allowsAttachmentHint': "For example a doctor's note.",
  'leaveSettings.everyone': 'Everyone can request it',
  'leaveSettings.everyoneHint': 'Off: grant it employee by employee.',
  'leaveSettings.onForm': 'Available on the request form',
  'leaveSettings.onFormHint': 'Switched-off types still label old requests.',
  'leaveSettings.syncQueued': 'Holiday update queued; the list refreshes once the worker has run',
  'leaveSettings.syncAlreadyQueued': 'An update is already queued',
  'leaveSettings.holidayRemoved': 'Holiday removed',
  'leaveSettings.year': 'Year',
  'leaveSettings.publicHolidaysIn': 'Public holidays in {country}',
  'leaveSettings.source.builtin': "From Bulk's built-in calendar on {date}.",
  'leaveSettings.source.nager': 'Synced from Nager.Date on {date}.',
  'leaveSettings.source.nagerPlus.one': "Synced from Nager.Date, plus one day from Bulk's built-in calendar on {date}.",
  'leaveSettings.source.nagerPlus.other': "Synced from Nager.Date, plus {count} days from Bulk's built-in calendar on {date}.",
  'leaveSettings.notObserved': 'Not observed: the Working week tab counts them as working days.',
  'leaveSettings.noneStored': 'None stored for this year yet.',
  'leaveSettings.update': 'Update',
  'leaveSettings.noPublicHolidays': 'No public holidays for {year}.',
  'leaveSettings.addedByBulk': 'added by Bulk',
  'leaveSettings.closures': 'Gym closures and extra days off',
  'leaveSettings.closuresHint': 'Days nobody works, on top of public holidays. Annual ones repeat every year.',
  'leaveSettings.add': 'Add',
  'leaveSettings.noneIn': 'None in {year}.',
  'leaveSettings.everyYearSuffix': 'every year',
  'leaveSettings.removeTitle': 'Remove this day off?',
  'leaveSettings.removeDescription': '{name} becomes a working day again.',
  'leaveSettings.remove': 'Remove',
  'leaveSettings.dayOffUpdated': 'Day off updated',
  'leaveSettings.dayOffAdded': 'Day off added',
  'leaveSettings.addDayOff': 'Add a day off',
  'leaveSettings.holidayPlaceholder': 'Gym closed for renovation',
  'leaveSettings.lastDayHint': 'The same as the first for a single day.',
  'leaveSettings.everyYear': 'Every year',
  'leaveSettings.everyYearHint': 'Repeats on the same dates from this year on.',
  'leaveSettings.saved': 'Leave settings saved',
  'leaveSettings.weekDescription': 'Days that count when a request is measured in working days. Public holidays and gym closures on these days do not count.',
  'leaveSettings.workingDays': 'Working days',
  'leaveSettings.pickOneDay': 'Pick at least one working day.',
  'leaveSettings.observe': 'Observe public holidays',
  'leaveSettings.observeHint': "Public holidays of the gym's country are days off.",
  'leaveSettings.rules': 'Rules for requests',
  'leaveSettings.startingPeriod': 'Starting period (months)',
  'leaveSettings.startingPeriodHint': "New employees wait this long before types marked 'Only after the starting period'. 0 means no wait.",
  'leaveSettings.furthest': 'Furthest ahead (days)',
  'leaveSettings.furthestHint': 'How far in advance leave can be requested.',
  'leaveSettings.hours': 'Working hours',
  'leaveSettings.hoursHint': 'Shown to the team; they do not change any count.',
  'leaveSettings.dayStarts': 'Day starts',
  'leaveSettings.dayEnds': 'Day ends',
  'leaveSettings.breakStarts': 'Break starts',
  'leaveSettings.breakEnds': 'Break ends',
  'leave.attachment.label': 'Doctor’s note',
  'leave.attachment.hint': 'Optional. A PDF or a photo, up to 10 MB. Only you, whoever approves leave and the accountant can open it.',
  'leave.attachment.open': 'Open the attached note',
  'leave.attachment.attach': 'Attach a note',
  'leave.attachment.replace': 'Replace note',
  'leave.attachment.remove': 'Remove note',
  'leave.attachment.added': 'Note attached',
  'leave.attachment.removed': 'Note removed',
  'leave.attachment.addLater': 'Add a note',
  'leave.attachment.afterApproval': 'added after approval',
  'leave.attachment.tooLarge': 'The file is larger than 10 MB',
  'leave.attachment.failedAfterSend': 'The request was sent, but the note was not attached. Attach it from your request.',
};

export const ka: Record<keyof typeof en, string> = {
  'enum.leaveStatus.CANCELLATION_REQUESTED': 'მოთხოვნილია გაუქმება',
  'leave.workingDays.one': '{count} სამუშაო დღე',
  'leave.workingDays.other': '{count} სამუშაო დღე',
  'leave.warning.one': '{names} ამ დღეებში ასევე შვებულებაშია; განყოფილებაში ერთდროულად {limit} ადამიანის შვებულებაა დაშვებული.',
  'leave.warning.other': '{names} ამ დღეებში ასევე შვებულებაში არიან; განყოფილებაში ერთდროულად {limit} ადამიანის შვებულებაა დაშვებული.',
  'leave.quoted': '„{text}“',
  'leave.unpaid': 'ანაზღაურების გარეშე',
  'leave.unpaidSuffix': 'ანაზღაურების გარეშე',
  'leave.waitingApproval': 'ელოდება დამტკიცებას',
  'leave.firstDay': 'პირველი დღე',
  'leave.lastDay': 'ბოლო დღე',
  'leave.requestUpdated': 'მოთხოვნა განახლდა',
  'leave.recorded': 'შვებულება აღირიცხა',
  'leave.sent': 'მოთხოვნა დასამტკიცებლად გაიგზავნა',
  'leave.employee': 'თანამშრომელი',
  'leave.choosePerson': 'აირჩიეთ თანამშრომელი',
  'leave.type': 'შვებულების სახეობა',
  'leave.upTo.one': 'მაქსიმუმ {count} სამუშაო დღე',
  'leave.upTo.other': 'მაქსიმუმ {count} სამუშაო დღე',
  'leave.noLimit': 'ერთი მოთხოვნის ხანგრძლივობა შეუზღუდავია',
  'leave.noteHint': 'არასავალდებულო. ხედავენ დამმტკიცებლები და ბუღალტერი; კალენდარში კოლეგები ვერ ხედავენ.',
  'leave.recordApproved': 'დამტკიცებულად აღრიცხვა',
  'leave.recordApprovedHint': 'უკვე შეთანხმებული ან უკვე გამოყენებული შვებულებისთვის; წინასწარი შეტყობინების წესები ასეთ ჩანაწერზე არ ვრცელდება.',
  'leave.pickDates': 'აირჩიეთ თარიღები, რომ ნახოთ, რამდენი სამუშაო დღეა.',
  'leave.counting': 'ითვლება…',
  'leave.leftAfter': 'ამის შემდეგ ნაშთი: {after} / {total}',
  'leave.leftThisYear': 'წლის ნაშთი: {left}',
  'leave.noAllowance': 'წლიურ ლიმიტს არ იყენებს',
  'leave.skips': 'არ ითვლება: {dates}',
  'leave.saveDates': 'თარიღების შენახვა',
  'leave.recordLeave': 'შვებულების აღრიცხვა',
  'leave.fileRequest': 'მოთხოვნის შეტანა',
  'leave.sendRequest': 'მოთხოვნის გაგზავნა',
  'leave.you': '{name} (თქვენ)',

  'leaveRule.LEAVE_DATES_BACKWARDS': 'ბოლო დღე პირველ დღეზე ადრეა.',
  'leaveRule.LEAVE_TYPE_UNAVAILABLE': 'შვებულების ეს სახეობა ამ თანამშრომლისთვის ხელმისაწვდომი არ არის.',
  'leaveRule.LEAVE_OUTSIDE_EMPLOYMENT': 'თარიღები სამუშაო პერიოდს სცდება.',
  'leaveRule.LEAVE_NO_WORKING_DAYS': 'ამ თარიღებში სამუშაო დღე არ არის.',
  'leaveRule.LEAVE_OVERLAPS': 'ეს თარიღები იმავე თანამშრომლის სხვა მოთხოვნას ემთხვევა.',
  'leaveRule.LEAVE_MAX_CONSECUTIVE.one': 'ერთ მოთხოვნაში მაქსიმუმ {count} სამუშაო დღე.',
  'leaveRule.LEAVE_MAX_CONSECUTIVE.other': 'ერთ მოთხოვნაში მაქსიმუმ {count} სამუშაო დღე.',
  'leaveRule.LEAVE_NOT_ELIGIBLE': 'ხელმისაწვდომია მოსაცდელი პერიოდის შემდეგ, თარიღიდან: {date}.',
  'leaveRule.LEAVE_TOO_FAR_AHEAD.one': 'მოთხოვნა შესაძლებელია მაქსიმუმ {count} დღით ადრე.',
  'leaveRule.LEAVE_TOO_FAR_AHEAD.other': 'მოთხოვნა შესაძლებელია მაქსიმუმ {count} დღით ადრე.',
  'leaveRule.LEAVE_MIN_NOTICE.one': 'საჭიროა {count} დღით ადრე მოთხოვნა: პირველი დღე შეიძლება იყოს არაუადრეს {date}.',
  'leaveRule.LEAVE_MIN_NOTICE.other': 'საჭიროა {count} დღით ადრე მოთხოვნა: პირველი დღე შეიძლება იყოს არაუადრეს {date}.',
  'leaveRule.notInPast': 'პირველი დღე წარსულში ვერ იქნება. უკვე გამოყენებულ დღეებს დამმტკიცებელი აღრიცხავს.',
  'leaveRule.LEAVE_ALLOWANCE_EXCEEDED.one': '{year} წელს დარჩენილია მხოლოდ {count} დღე.',
  'leaveRule.LEAVE_ALLOWANCE_EXCEEDED.other': '{year} წელს დარჩენილია მხოლოდ {count} დღე.',

  'leavePage.description': 'ვინ როდის ისვენებს, თქვენი ნაშთი და მოთხოვნები. შვებულება სამუშაო დღეებით ითვლება.',
  'leavePage.reportSick': 'ავადმყოფობის შეტყობინება',
  'leavePage.requestHint': 'თარიღების არჩევისას სამუშაო დღეები ავტომატურად ითვლება; შემდეგ გადაწყვეტილებას დამმტკიცებელი იღებს.',
  'leavePage.noRecordHint': 'ხედავთ, ვინ ისვენებს, მაგრამ შვებულების მოსათხოვად თანამშრომლის ჩანაწერია საჭირო. სთხოვეთ მფლობელს, დაგამატოთ გუნდში (გუნდი → თანამშრომლები) და ჩანაწერი თქვენს ანგარიშს დაუკავშიროს.',
  'leavePage.noRecordHintManager': 'ხედავთ, ვინ ისვენებს. თავად შვებულების მოსათხოვად ან ავადმყოფობის შესატყობინებლად დაამატეთ საკუთარი თავი გუნდში და ჩანაწერი თქვენს ანგარიშს დაუკავშირეთ.',
  'leavePage.addMe': 'საკუთარი თავის დამატება გუნდში',
  'sick.description': 'დღევანდელი დღე უკვე შევსებულია; შეცვალეთ ბოლო დღე, თუ იცით. ექიმის ცნობა შეგიძლიათ ახლავე დაურთოთ ან მოგვიანებით დაამატოთ.',
  'sick.descriptionApprover': 'საკუთარი თავისთვის ან გუნდის წევრისთვის, რომელმაც ავადმყოფობის შესახებ შეგატყობინათ. სხვისთვის აღრიცხვისას წინასწარი შეტყობინების წესი არ მოქმედებს, ამიტომ უკვე გასული დღეც შეიძლება.',
  'sick.descriptionOthers': 'გუნდის წევრისთვის, რომელმაც ავადმყოფობის შესახებ შეგატყობინათ. სხვისთვის აღრიცხვისას წინასწარი შეტყობინების წესი არ მოქმედებს, ამიტომ უკვე გასული დღეც შეიძლება.',
  'sick.unavailable': 'ავადმყოფობის შვებულება გამორთულია',
  'sick.unavailableHint': 'სთხოვეთ მფლობელს, ჩართოს ის: გუნდი → შვებულების წესები.',
  'myPay.description': 'თქვენი სახელფასო ფურცლები და, საათობრივი ანაზღაურებისას, ნამუშევარი საათები.',

  'approvals.description': 'გადაწყვეტილების მომლოდინე შვებულებები, უახლოესი პირველად. გაფრთხილება ნიშნავს, რომ განყოფილებაში დასაშვებზე მეტი ადამიანი იქნება შვებულებაში; ის მოთხოვნას არასოდეს ბლოკავს.',
  'approvals.fileForSomeone': 'სხვის სახელით შეტანა',
  'approvals.fileDescription': 'თანამშრომლისთვის, რომელსაც ანგარიში არ აქვს, ან პირადად შეთანხმებული შვებულებისთვის. მოქმედებს იგივე წესები, გარდა წინასწარი შეტყობინებისა.',
  'approvals.empty': 'გადასაწყვეტი არაფერია',
  'approvals.emptyHint': 'აქ ჩნდება ახალი მოთხოვნები და დამტკიცებული შვებულების გაუქმების მოთხოვნები.',
  'approvals.wantsToCancel': 'გაუქმებას ითხოვს: „{reason}“',
  'approvals.filedBy': 'შეიტანა: {name}',
  'approvals.ownLeave': 'ეს თქვენი შვებულებაა: მასზე სხვა იღებს გადაწყვეტილებას.',
  'approvals.keepApproved': 'დამტკიცებულად დატოვება',
  'approvals.cancelLeave': 'შვებულების გაუქმება',
  'approvals.reject': 'უარყოფა',
  'approvals.approve': 'დამტკიცება',
  'approvals.summary': '{name} · {type} · {range} ({days})',
  'approvals.approveTitle': 'შვებულების დამტკიცება',
  'approvals.approveNote': 'შენიშვნა თანამშრომლისთვის (არასავალდებულო)',
  'approvals.sessions.count.one': 'ამ დღეებში {name}-თან დაჯავშნილია {count} ინდივიდუალური სესია',
  'approvals.sessions.count.other': 'ამ დღეებში {name}-თან დაჯავშნილია {count} ინდივიდუალური სესია',
  'approvals.sessions.choose': 'დადასტურებამდე აირჩიეთ, რა მოუვა მათ.',
  'approvals.sessions.cancel': 'გაუქმდეს: თითოეული წევრი მიიღებს შეტყობინებას და სესია დაუბრუნდება',
  'approvals.sessions.keep': 'დარჩეს დაჯავშნილი',
  'approvals.approved': '{name}: დამტკიცდა',
  'approvals.rejectTitle': 'შვებულების უარყოფა',
  'approvals.whyVisible': 'მიზეზი (არასავალდებულო, თანამშრომელი დაინახავს)',
  'approvals.rejected': '{name}: უარყოფილია',
  'approvals.cancelTitle': 'ამ შვებულების გაუქმება',
  'approvals.cancelConfirm': 'შვებულების გაუქმება',
  'approvals.cancelNote': 'შენიშვნა (არასავალდებულო)',
  'approvals.cancelled': '{name}: შვებულება გაუქმდა',
  'approvals.keepTitle': 'შვებულების დამტკიცებულად დატოვება',
  'approvals.kept': '{name}: შვებულება დამტკიცებული რჩება',

  'timeOff.noRecord': 'აქ თანამშრომლის ჩანაწერი არ გაქვთ',
  'timeOff.noRecordHint': 'შვებულება და ხელფასი თანამშრომლის ჩანაწერზეა მიბმული. სთხოვეთ მფლობელს, დაგამატოთ გუნდში (გუნდი → თანამშრომლები) და ჩანაწერი თქვენს ანგარიშს დაუკავშიროს.',
  'timeOff.tab.payslips': 'სახელფასო ფურცლები',
  'timeOff.request': 'შვებულების მოთხოვნა',
  'timeOff.noTypes': 'შვებულების სახეობები ხელმისაწვდომი არ არის',
  'timeOff.noTypesHint': 'ჰკითხეთ მფლობელს, შვებულების რომელი სახეობებით შეგიძლიათ სარგებლობა.',
  'timeOff.yourRequests': 'თქვენი მოთხოვნები',
  'timeOff.noRequests': 'მოთხოვნები ჯერ არ არის',
  'timeOff.noRequestsHint': 'გაგზავნილი მოთხოვნები აქ ჩანს სტატუსთან ერთად.',
  'timeOff.leftIn': '{year} წლის ნაშთი',
  'timeOff.leftHint': 'სამუშაო დღე, მომლოდინე მოთხოვნების გათვალისწინებით',
  'timeOff.taken': 'გამოყენებული ან დამტკიცებული',
  'timeOff.takenHint': 'სახეობებიდან, რომლებიც წლიურ ლიმიტს იყენებს',
  'timeOff.startingPeriod': 'მოსაცდელი პერიოდი',
  'timeOff.eligibleFrom': 'უფლების მოპოვების თარიღი',
  'timeOff.done': 'გასულია',
  'timeOff.resetsOn': 'წლიური ლიმიტი თავიდან დაიწყება: {date}',
  'timeOff.withdrawn': 'მოთხოვნა გამოთხოვილია',
  'timeOff.cancellationAsked': 'გაუქმება მოთხოვნილია',
  'timeOff.youAskedToCancel': 'გაუქმება მოითხოვეთ: {reason}',
  'timeOff.dates': 'თარიღები',
  'timeOff.withdraw': 'გამოთხოვა',
  'timeOff.askToCancel': 'გაუქმების მოთხოვნა',
  'timeOff.changeDates': 'თარიღების შეცვლა',
  'timeOff.changeDatesHint': 'მოთხოვნა მოლოდინში რჩება და წესები თავიდან შემოწმდება.',
  'timeOff.askToCancelTitle': 'მოითხოვთ ამ შვებულების გაუქმებას?',
  'timeOff.askToCancelHint': 'დამტკიცებული შვებულება უქმდება, როცა დამმტკიცებელი დაეთანხმება; მაშინ დღეებიც დაგიბრუნდებათ.',
  'timeOff.keepIt': 'დატოვება',
  'timeOff.why': 'მიზეზი',

  'leaveCalendar.today': 'დღეს',
  'leaveCalendar.whose': 'ვისი შვებულება',
  'leaveCalendar.mine': 'ჩემი',
  'leaveCalendar.team': 'გუნდი',
  'leaveCalendar.layout': 'ხედი',
  'leaveCalendar.layoutMonth': 'თვე',
  'leaveCalendar.layoutPeople': 'თანამშრომლებით',
  'leaveCalendar.more': '+{count} სხვა',
  'leaveCalendar.onLeave.one': 'შვებულებაში: {count}',
  'leaveCalendar.onLeave.other': 'შვებულებაში: {count}',
  'leaveCalendar.nobodyOffDay': 'ამ დღეს შვებულებაში არავინაა.',
  'leaveCalendar.youAreNotOff': 'ამ დღეს შვებულებაში არ ხართ.',
  'leaveCalendar.requestFrom': 'შვებულების მოთხოვნა ამ დღიდან',
  'leaveCalendar.sick': 'ავადმყოფობის შვებულება',
  'leaveCalendar.off': 'შვებულებაში',
  'leaveCalendar.previousMonth': 'წინა თვე',
  'leaveCalendar.nextMonth': 'შემდეგი თვე',
  'leaveCalendar.report': '{year} წლის ანგარიში',
  'leaveCalendar.department': 'განყოფილება',
  'leaveCalendar.allDepartments': 'ყველა განყოფილება',
  'leaveCalendar.notWorkingDay': 'არასამუშაო დღე',
  'leaveCalendar.nobodyOff': 'ამ თვეში შვებულებაში არავინაა.',
  'leaveCalendar.person': 'თანამშრომელი',
  'leaveCalendar.approved': 'დამტკიცებული',
  'leaveCalendar.pending': 'მოლოდინში',
  'leaveCalendar.cancellationAsked': 'მოთხოვნილია გაუქმება',
  'leaveCalendar.nobodyWorks': 'არავინ მუშაობს',

  'leaveSettings.description': 'შვებულების სახეობები, დასვენების დღეები და სამუშაო კვირა. ყოველი მოთხოვნა სამუშაო დღეებით ითვლება და ამ წესებით მოწმდება.',
  'leaveSettings.tab.types': 'შვებულების სახეობები',
  'leaveSettings.tab.holidays': 'დასვენების დღეები',
  'leaveSettings.tab.week': 'სამუშაო კვირა',
  'leaveSettings.upToPerRequest.one': 'ერთ მოთხოვნაზე მაქსიმუმ {count} სამუშაო დღე',
  'leaveSettings.upToPerRequest.other': 'ერთ მოთხოვნაზე მაქსიმუმ {count} სამუშაო დღე',
  'leaveSettings.notice.one': 'წინასწარი შეტყობინება: {count} დღე',
  'leaveSettings.notice.other': 'წინასწარი შეტყობინება: {count} დღე',
  'leaveSettings.switchedOn': 'შვებულების სახეობა ჩაირთო',
  'leaveSettings.switchedOff': 'შვებულების სახეობა გამოირთო',
  'leaveSettings.typeDeleted': 'შვებულების სახეობა წაიშალა',
  'leaveSettings.newType': 'შვებულების ახალი სახეობა',
  'leaveSettings.noTypes': 'შვებულების სახეობები არ არის',
  'leaveSettings.noTypesHint': 'დაამატეთ შვებულების სახეობები, რომელთა მოთხოვნაც თქვენს გუნდს შეეძლება.',
  'leaveSettings.paid': 'ანაზღაურებადი',
  'leaveSettings.usesAllowance': 'იყენებს წლიურ ლიმიტს',
  'leaveSettings.afterStartingPeriod': 'მოსაცდელი პერიოდის შემდეგ',
  'leaveSettings.attachment': 'დანართი',
  'leaveSettings.grantedPerEmployee': 'ენიჭება ინდივიდუალურად',
  'leaveSettings.switchedOffBadge': 'გამორთული',
  'leaveSettings.availableNamed': '{name} — ხელმისაწვდომია მოთხოვნის ფორმაში',
  'leaveSettings.available': 'ხელმისაწვდომი',
  'leaveSettings.editNamed': 'რედაქტირება: {name}',
  'leaveSettings.deleteNamed': 'წაშლა: {name}',
  'leaveSettings.builtinNoDelete': 'ჩაშენებული სახეობის წაშლა შეუძლებელია; სანაცვლოდ გამორთეთ',
  'leaveSettings.deleteTitle': 'წაიშალოს შვებულების სახეობა?',
  'leaveSettings.deleteDescription': '{name} გაქრება მოთხოვნის ფორმიდან და ყველა თანამშრომლის მინიჭებული სახეობებიდან.',
  'leaveSettings.typeUpdated': 'შვებულების სახეობა განახლდა',
  'leaveSettings.typeAdded': 'შვებულების სახეობა დაემატა',
  'leaveSettings.keyStays': 'გასაღები {key} სახელის შეცვლისას არ იცვლება.',
  'leaveSettings.keyFromName': 'გასაღები ინგლისური სახელიდან იქმნება და არასოდეს იცვლება.',
  'leaveSettings.addType': 'სახეობის დამატება',
  'leaveSettings.nameEnglish': 'სახელი (ინგლისურად)',
  'leaveSettings.typePlaceholder': 'ქორწილის შვებულება',
  'leaveSettings.otherLanguages': 'სახელი სხვა ენებზე',
  'leaveSettings.longest': 'ყველაზე გრძელი მოთხოვნა (სამუშაო დღე)',
  'leaveSettings.longestHint': 'დატოვეთ ცარიელი, თუ შეზღუდვა არ გჭირდებათ.',
  'leaveSettings.noticeLabel': 'წინასწარი შეტყობინება (კალენდარული დღე)',
  'leaveSettings.noticeHint': 'რამდენი დღით ადრე უნდა შევიდეს მოთხოვნა პირველ დღემდე.',
  'leaveSettings.paidHint': 'ანაზღაურების გარეშე დღეები ხელფასების გაანგარიშებისას თვიურ ხელფასს აკლდება.',
  'leaveSettings.usesAnnual': 'იყენებს წლიურ ლიმიტს',
  'leaveSettings.usesAnnualHint': 'გამოყენებული დღეები თანამშრომლის წლიურ ლიმიტს აკლდება.',
  'leaveSettings.onlyAfter': 'მხოლოდ მოსაცდელი პერიოდის შემდეგ',
  'leaveSettings.onlyAfterHint': 'პერიოდი მიეთითება ჩანართზე „სამუშაო კვირა“.',
  'leaveSettings.allowsAttachment': 'დანართი დასაშვებია',
  'leaveSettings.allowsAttachmentHint': 'მაგალითად, ექიმის ცნობა.',
  'leaveSettings.everyone': 'ყველას შეუძლია მოთხოვნა',
  'leaveSettings.everyoneHint': 'გამორთვის შემთხვევაში მიანიჭეთ თითოეულ თანამშრომელს ცალ-ცალკე.',
  'leaveSettings.onForm': 'ხელმისაწვდომია მოთხოვნის ფორმაში',
  'leaveSettings.onFormHint': 'გამორთული სახეობის სახელი ძველ მოთხოვნებზე მაინც ჩანს.',
  'leaveSettings.syncQueued': 'უქმე დღეების განახლება რიგშია; სია განახლდება, როცა ფონური პროცესი შესრულდება',
  'leaveSettings.syncAlreadyQueued': 'განახლება უკვე რიგშია',
  'leaveSettings.holidayRemoved': 'დასვენების დღე წაიშალა',
  'leaveSettings.year': 'წელი',
  'leaveSettings.publicHolidaysIn': 'უქმე დღეები: {country}',
  'leaveSettings.source.builtin': 'Bulk-ის ჩაშენებული კალენდრიდან, განახლდა {date}.',
  'leaveSettings.source.nager': 'სინქრონიზებულია Nager.Date-დან, {date}.',
  'leaveSettings.source.nagerPlus.one': 'სინქრონიზებულია Nager.Date-დან, დამატებით ერთი დღე Bulk-ის ჩაშენებული კალენდრიდან, {date}.',
  'leaveSettings.source.nagerPlus.other': 'სინქრონიზებულია Nager.Date-დან, დამატებით {count} დღე Bulk-ის ჩაშენებული კალენდრიდან, {date}.',
  'leaveSettings.notObserved': 'არ ითვლება დასვენების დღეებად: ჩანართის „სამუშაო კვირა“ პარამეტრებით ეს დღეები სამუშაოა.',
  'leaveSettings.noneStored': 'ამ წლისთვის ჯერ არაფერია შენახული.',
  'leaveSettings.update': 'განახლება',
  'leaveSettings.noPublicHolidays': '{year} წლისთვის უქმე დღეები არ არის.',
  'leaveSettings.addedByBulk': 'დაამატა Bulk-მა',
  'leaveSettings.closures': 'დარბაზის დახურვის დღეები და დამატებითი დასვენების დღეები',
  'leaveSettings.closuresHint': 'დღეები, როცა არავინ მუშაობს, უქმე დღეების გარდა. ყოველწლიური დღეები ყოველ წელს მეორდება.',
  'leaveSettings.add': 'დამატება',
  'leaveSettings.noneIn': '{year} წელს არ არის.',
  'leaveSettings.everyYearSuffix': 'ყოველ წელს',
  'leaveSettings.removeTitle': 'წაიშალოს ეს დასვენების დღე?',
  'leaveSettings.removeDescription': '{name} ისევ სამუშაო დღე გახდება.',
  'leaveSettings.remove': 'წაშლა',
  'leaveSettings.dayOffUpdated': 'დასვენების დღე განახლდა',
  'leaveSettings.dayOffAdded': 'დასვენების დღე დაემატა',
  'leaveSettings.addDayOff': 'დასვენების დღის დამატება',
  'leaveSettings.holidayPlaceholder': 'დარბაზი დაკეტილია რემონტის გამო',
  'leaveSettings.lastDayHint': 'ერთი დღისთვის მიუთითეთ იგივე, რაც პირველი.',
  'leaveSettings.everyYear': 'ყოველწლიური',
  'leaveSettings.everyYearHint': 'მეორდება იმავე თარიღებზე ამ წლიდან მოყოლებული.',
  'leaveSettings.saved': 'შვებულების წესები შენახულია',
  'leaveSettings.weekDescription': 'დღეები, რომლებიც ითვლება, როცა მოთხოვნა სამუშაო დღეებით იზომება. ამ დღეებზე მოსული უქმე დღეები და დარბაზის დახურვის დღეები არ ითვლება.',
  'leaveSettings.workingDays': 'სამუშაო დღეები',
  'leaveSettings.pickOneDay': 'აირჩიეთ მინიმუმ ერთი სამუშაო დღე.',
  'leaveSettings.observe': 'უქმე დღეების გათვალისწინება',
  'leaveSettings.observeHint': 'დარბაზის ქვეყნის უქმე დღეები დასვენების დღეებია.',
  'leaveSettings.rules': 'მოთხოვნების წესები',
  'leaveSettings.startingPeriod': 'პერიოდი, რომლის შემდეგაც შვებულება ხელმისაწვდომია (თვე)',
  'leaveSettings.startingPeriodHint': 'ახალი თანამშრომელი ამდენ ხანს ელოდება „მხოლოდ მოსაცდელი პერიოდის შემდეგ“ მონიშნულ სახეობებს. 0 ნიშნავს, რომ ლოდინი არ არის.',
  'leaveSettings.furthest': 'წინასწარ მოთხოვნის მაქსიმალური ვადა (დღე)',
  'leaveSettings.furthestHint': 'რამდენი დღით ადრე შეიძლება შვებულების მოთხოვნა.',
  'leaveSettings.hours': 'სამუშაო საათები',
  'leaveSettings.hoursHint': 'ჩანს გუნდისთვის; დღეების დათვლაზე გავლენა არ აქვს.',
  'leaveSettings.dayStarts': 'დღის დასაწყისი',
  'leaveSettings.dayEnds': 'დღის დასასრული',
  'leaveSettings.breakStarts': 'შესვენების დასაწყისი',
  'leaveSettings.breakEnds': 'შესვენების დასასრული',
  'leave.attachment.label': 'ექიმის ცნობა',
  'leave.attachment.hint': 'არასავალდებულო. PDF ან ფოტო, მაქსიმუმ 10 მბ. მისი გახსნა შეუძლიათ მხოლოდ თქვენ, შვებულების დამმტკიცებელს და ბუღალტერს.',
  'leave.attachment.open': 'მიმაგრებული ცნობის გახსნა',
  'leave.attachment.attach': 'ცნობის მიმაგრება',
  'leave.attachment.replace': 'ცნობის შეცვლა',
  'leave.attachment.remove': 'ცნობის წაშლა',
  'leave.attachment.added': 'ცნობა მიმაგრდა',
  'leave.attachment.removed': 'ცნობა წაიშალა',
  'leave.attachment.addLater': 'ცნობის დამატება',
  'leave.attachment.afterApproval': 'დამატებულია დამტკიცების შემდეგ',
  'leave.attachment.tooLarge': 'ფაილი 10 მბ-ზე დიდია',
  'leave.attachment.failedAfterSend': 'მოთხოვნა გაიგზავნა, მაგრამ ცნობა ვერ მიმაგრდა. მიამაგრეთ ის მოთხოვნიდან.',
};
